"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var FormControl_1 = require("@material-ui/core/FormControl");
var Select_1 = require("@material-ui/core/Select");
var MenuItem_1 = require("@material-ui/core/MenuItem");
var FormattedClassifierItem_1 = require("./../../i18n/FormattedClassifierItem");
var InputLabel_1 = require("@material-ui/core/InputLabel");
var Theme_1 = require("./Theme");
var FormControlSelect = /** @class */ (function (_super) {
    __extends(FormControlSelect, _super);
    function FormControlSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormControlSelect.prototype.render = function () {
        var _a = this.props, options = _a.options, id = _a.id, label = _a.label, className = _a.className, value = _a.value, onChange = _a.onChange, style = _a.style, disabled = _a.disabled, shrinkLabel = _a.shrinkLabel;
        return (React.createElement(Theme_1.default, { color: "primary" },
            React.createElement(reactstrap_1.FormGroup, { className: "".concat(className).concat(disabled ? " disabled" : ""), style: style },
                React.createElement(FormControl_1.default, { style: { width: "100%" } },
                    React.createElement(InputLabel_1.default, { htmlFor: id, shrink: shrinkLabel }, label),
                    React.createElement(Select_1.default, { value: value, id: id, disabled: disabled, style: { width: "100%" }, onChange: onChange }, options.map(function (option) {
                        return (React.createElement(MenuItem_1.default, { key: option.key, value: option.key },
                            React.createElement(FormattedClassifierItem_1.default, { key: option.key, prefix: option.prefix, description: option.description, id: option.key })));
                    }))))));
    };
    return FormControlSelect;
}(React.Component));
exports.default = FormControlSelect;
//# sourceMappingURL=FormControlSelect.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/components/dist/theme/mdb/FormControlSelect.js
// module id = 2235
// module chunks = 0